/* eslint-disable */
<template lang="html">
  <v-app id="inspire">
    <div
      class="display-1 
                d-flex 
                justify-center 
                text-center
                mt-12
                pt-4
                grey--text 
                text--darken-2"
      v-text="name"
    ></div>
    <v-container class="my-5">
      <v-layout row wrap>
        <v-card
          class="mx-auto 
                  mb-4
                  mt-2"
          max-width="344"
          v-for="(product, index) in products"
          :key="index"
        >
          <router-link :to="product.prodLinkpass" :event="product.clicking">
            <v-img
              v-bind:src="product.prodImgUrl"
              :lazy-src="lazyImg"
              height="200px"
            ></v-img>

            <v-card-title style="word-break: normal;" class="text-center">
              <span style="margin: 0 auto" v-text="product.prodName"> </span>
            </v-card-title>
          </router-link>
        </v-card>
        <!-- ssss -->
      </v-layout>
    </v-container>
  </v-app>
</template>
<script>
export default {
  data: () => ({
    name: "ინდუსტრიული ზეთები",
    text: "This is sash product",
    show: false,
    alignmentsAvailable: ["start", "center", "end", "baseline", "stretch"],
    alignment: "center",
    dense: false,
    justifyAvailable: [
      "start",
      "center",
      "end",
      "space-around",
      "space-between"
    ],
    justify: "center",
    lazyImg: require("@/assets/lazy_engine_oil.png"),
    products: [
      {
        prodName: "HIDROL",
        prodImgUrl:
          "https://cdn5.vectorstock.com/i/1000x1000/82/89/eps-10-gold-olive-or-engine-oil-splash-3d-vector-24398289.jpg",
        prodLinkpass: "/hidrol",
        clicking: "click"
      }
    ]
  })
};
</script>
